module.exports = __webpack_public_path__ + "static/media/scan.e0153db2.svg";